(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["choices-entrance"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const entrance = document.querySelector('[data-choices-entrance]');
    if (!entrance || entrance.dataset.entranceReady === 'true') return;
    entrance.dataset.entranceReady = 'true';

    const storageKey = 'choices-entrance-viewed';
    const trigger = entrance.querySelector('[data-entrance-trigger]');
    const video = entrance.querySelector('[data-entrance-video]');
    const globe = entrance.querySelector('[data-entrance-globe-video]');
    const media = [video, globe].filter(Boolean);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pending = new WeakSet();
    let alreadyEntered = false;

    try {
      alreadyEntered = window.sessionStorage.getItem(storageKey) === 'true';
    } catch (error) {
      alreadyEntered = false;
    }
    if (alreadyEntered) return;

    // Do not set autoplay: iOS Low Power Mode can force native controls on
    // autoplay elements even when controls=false and the CSS says otherwise.
    // Muted programmatic playback is attempted, with honest poster fallback.
    const conceal = (node, state) => {
      node.style.opacity = '0';
      node.dataset.playbackState = state;
    };
    const reveal = (node) => {
      if (entrance.hidden || document.hidden || node.paused || node.readyState < 2) return;
      node.style.opacity = '1';
      node.dataset.playbackState = 'playing';
    };

    media.forEach((node) => {
      node.controls = false;
      node.removeAttribute('controls');
      node.removeAttribute('autoplay');
      node.muted = true;
      node.defaultMuted = true;
      node.playsInline = true;
      node.setAttribute('muted', '');
      node.setAttribute('playsinline', '');
      node.setAttribute('webkit-playsinline', '');
      node.setAttribute('tabindex', '-1');
      conceal(node, 'poster');
      node.addEventListener('playing', () => {
        if (typeof node.requestVideoFrameCallback === 'function') {
          node.requestVideoFrameCallback(() => reveal(node));
        }
      });
      // Also covers browsers without requestVideoFrameCallback.
      node.addEventListener('timeupdate', () => {
        if (node.currentTime > 0 && node.dataset.playbackState !== 'playing') reveal(node);
      });
      ['pause', 'waiting', 'emptied', 'error'].forEach((eventName) => {
        node.addEventListener(eventName, () => conceal(node, eventName));
      });
    });

    const playMedia = () => {
      if (reducedMotion || entrance.hidden || document.hidden) return;
      media.forEach((node) => {
        if (pending.has(node) || (!node.paused && node.readyState >= 2)) return;
        node.muted = true;
        node.defaultMuted = true;
        try {
          const promise = node.play();
          if (promise && typeof promise.then === 'function') {
            pending.add(node);
            promise.then(() => pending.delete(node), (error) => {
              pending.delete(node);
              conceal(node, error && error.name === 'NotAllowedError' ? 'blocked' : 'unavailable');
            });
          }
        } catch (error) {
          conceal(node, 'unavailable');
        }
      });
    };
    const pauseMedia = () => media.forEach((node) => {
      node.pause();
      conceal(node, 'paused');
    });
    const onVisibility = () => document.hidden ? pauseMedia() : playMedia();

    entrance.hidden = false;
    document.documentElement.classList.add('choices-entrance-active');
    if (!reducedMotion) {
      media.forEach((node) => {
        node.preload = 'auto';
        if (node.dataset.src) node.src = node.dataset.src;
        node.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        node.load();
      });
      playMedia();
    }

    // A real touch/click retries policy-blocked playback without displaying a
    // play icon or consuming the globe's existing one-tap entry action.
    const gestureOptions = { capture: true, passive: true };
    document.addEventListener('touchend', playMedia, gestureOptions);
    document.addEventListener('click', playMedia, gestureOptions);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pageshow', playMedia);
    window.addEventListener('pagehide', pauseMedia);

    const enterStore = () => {
      if (entrance.classList.contains('is-entering')) return;
      entrance.classList.add('is-entering');
      trigger?.setAttribute('disabled', '');
      if (globe) globe.playbackRate = reducedMotion ? 1 : 3.25;
      try {
        window.sessionStorage.setItem(storageKey, 'true');
      } catch (error) {
      }
      window.setTimeout(() => {
        pauseMedia();
        entrance.hidden = true;
        document.documentElement.classList.remove('choices-entrance-active');
        document.removeEventListener('touchend', playMedia, true);
        document.removeEventListener('click', playMedia, true);
        document.removeEventListener('visibilitychange', onVisibility);
        window.removeEventListener('pageshow', playMedia);
        window.removeEventListener('pagehide', pauseMedia);
        window.scrollTo({ top: 0, behavior: 'instant' });
        const destination = document.querySelector('[data-choices-orbit]');
        if (destination) {
          destination.setAttribute('tabindex', '-1');
          destination.focus({ preventScroll: true });
        }
      }, reducedMotion ? 320 : 1500);
    };
    trigger?.addEventListener('click', enterStore);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choices-lookbook-page"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-choices-lookbook]').forEach(root=>{const looks=[...root.querySelectorAll('[data-look]')],thumbs=[...root.querySelectorAll('.choices-lookbook__thumbs a')],count=root.querySelector('[data-look-count]'),siteHeader=document.querySelector('.shopify-section-group-header-group');let active=0;const fit=()=>root.style.setProperty('--site-header',Math.max(0,siteHeader?.getBoundingClientRect().bottom||0)+'px');const show=i=>{active=(i+looks.length)%looks.length;looks.forEach((look,n)=>look.classList.toggle('is-active',n===active));thumbs.forEach((thumb,n)=>thumb.classList.toggle('is-active',n===active));count.textContent=String(active+1).padStart(2,'0')+' / '+String(looks.length).padStart(2,'0');history.replaceState(null,'','#look-'+(active+1))};const hash=()=>{const n=Number(location.hash.replace('#look-',''));return Number.isFinite(n)&&n>0&&n<=looks.length?n-1:0};root.querySelector('[data-look-prev]')?.addEventListener('click',()=>show(active-1));root.querySelector('[data-look-next]')?.addEventListener('click',()=>show(active+1));thumbs.forEach((thumb,i)=>thumb.addEventListener('click',e=>{e.preventDefault();show(i)}));document.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')show(active-1);if(e.key==='ArrowRight')show(active+1)});window.addEventListener('hashchange',()=>show(hash()));window.addEventListener('resize',fit,{passive:true});window.scrollTo(0,0);fit();show(hash());requestAnimationFrame(()=>{window.scrollTo(0,0);fit()})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choices-product-orbit"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cutoutCache = new Map();
    const cutoutPending = new Map();

    const averagePatch = (pixels, width, height, startX, startY, patchWidth, patchHeight) => {
      let red = 0;
      let green = 0;
      let blue = 0;
      let count = 0;
      const endX = Math.min(width, startX + patchWidth);
      const endY = Math.min(height, startY + patchHeight);

      for (let y = Math.max(0, startY); y < endY; y += 1) {
        for (let x = Math.max(0, startX); x < endX; x += 1) {
          const offset = (y * width + x) * 4;
          if (pixels[offset + 3] < 200) continue;
          red += pixels[offset];
          green += pixels[offset + 1];
          blue += pixels[offset + 2];
          count += 1;
        }
      }

      return count ? [red / count, green / count, blue / count] : [255, 255, 255];
    };

    const createCutout = (source, maximumSize) => {
      const absoluteSource = new URL(source, window.location.href).href;
      const cacheKey = `${maximumSize}:${absoluteSource}`;
      if (cutoutCache.has(cacheKey)) return Promise.resolve(cutoutCache.get(cacheKey));
      if (cutoutPending.has(cacheKey)) return cutoutPending.get(cacheKey);

      const promise = new Promise((resolve, reject) => {
        const sourceImage = new Image();
        sourceImage.crossOrigin = 'anonymous';
        sourceImage.decoding = 'async';
        sourceImage.onload = () => {
          try {
            const scale = Math.min(1, maximumSize / Math.max(sourceImage.naturalWidth, sourceImage.naturalHeight));
            const width = Math.max(1, Math.round(sourceImage.naturalWidth * scale));
            const height = Math.max(1, Math.round(sourceImage.naturalHeight * scale));
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d', { willReadFrequently: true });
            if (!context) throw new Error('Canvas is unavailable');
            canvas.width = width;
            canvas.height = height;
            context.drawImage(sourceImage, 0, 0, width, height);

            const imageData = context.getImageData(0, 0, width, height);
            const pixels = imageData.data;
            const patchWidth = Math.max(2, Math.round(width * 0.045));
            const patchHeight = Math.max(2, Math.round(height * 0.045));
            const backgrounds = [
              averagePatch(pixels, width, height, 0, 0, patchWidth, patchHeight),
              averagePatch(pixels, width, height, width - patchWidth, 0, patchWidth, patchHeight),
              averagePatch(pixels, width, height, 0, height - patchHeight, patchWidth, patchHeight),
              averagePatch(pixels, width, height, width - patchWidth, height - patchHeight, patchWidth, patchHeight)
            ];
            const visited = new Uint8Array(width * height);
            const queue = new Int32Array(width * height);
            let head = 0;
            let tail = 0;

            const isBackground = (index) => {
              const offset = index * 4;
              if (pixels[offset + 3] < 16) return true;
              const red = pixels[offset];
              const green = pixels[offset + 1];
              const blue = pixels[offset + 2];
              let nearest = Infinity;
              backgrounds.forEach((background) => {
                const distance = Math.hypot(red - background[0], green - background[1], blue - background[2]);
                nearest = Math.min(nearest, distance);
              });
              return nearest < 38;
            };

            const enqueue = (index) => {
              if (visited[index] || !isBackground(index)) return;
              visited[index] = 1;
              queue[tail] = index;
              tail += 1;
            };

            for (let x = 0; x < width; x += 1) {
              enqueue(x);
              enqueue((height - 1) * width + x);
            }
            for (let y = 1; y < height - 1; y += 1) {
              enqueue(y * width);
              enqueue(y * width + width - 1);
            }

            while (head < tail) {
              const index = queue[head];
              head += 1;
              pixels[index * 4 + 3] = 0;
              const x = index % width;
              const y = Math.floor(index / width);
              if (x > 0) enqueue(index - 1);
              if (x < width - 1) enqueue(index + 1);
              if (y > 0) enqueue(index - width);
              if (y < height - 1) enqueue(index + width);
            }

            context.putImageData(imageData, 0, 0);
            canvas.toBlob((blob) => {
              if (!blob) {
                reject(new Error('Cutout could not be created'));
                return;
              }
              const objectUrl = URL.createObjectURL(blob);
              cutoutCache.set(cacheKey, objectUrl);
              resolve(objectUrl);
            }, 'image/png');
          } catch (error) {
            reject(error);
          }
        };
        sourceImage.onerror = () => reject(new Error('Image could not be loaded'));
        sourceImage.src = absoluteSource;
      }).finally(() => cutoutPending.delete(cacheKey));

      cutoutPending.set(cacheKey, promise);
      return promise;
    };

    const applyCutout = async (target, source, maximumSize) => {
      if (!target || !source) return;
      const absoluteSource = new URL(source, window.location.href).href;
      target.dataset.cutoutSource = absoluteSource;
      target.dataset.cutoutState = 'pending';

      try {
        const cutout = await createCutout(absoluteSource, maximumSize);
        if (target.dataset.cutoutSource !== absoluteSource) return;
        target.srcset = '';
        target.src = cutout;
        target.dataset.cutoutState = 'ready';
      } catch (error) {
        if (target.dataset.cutoutSource !== absoluteSource) return;
        target.dataset.cutoutState = 'fallback';
      }
    };

    const initializeOrbit = (root) => {
      if (!root || root.dataset.orbitReady === 'true') return;
      root.dataset.orbitReady = 'true';

      const stage = root.querySelector('[data-orbit-stage]');
      const thumbs = Array.from(root.querySelectorAll('[data-orbit-index]'));
      const galleries = Array.from(root.querySelectorAll('[data-orbit-gallery]'));
      const image = root.querySelector('[data-orbit-image]');
      const link = root.querySelector('[data-orbit-link]');
      const button = root.querySelector('[data-orbit-button]');
      const title = root.querySelector('[data-orbit-title]');
      const price = root.querySelector('[data-orbit-price]');
      const current = root.querySelector('[data-orbit-current]');
      const previous = root.querySelector('[data-orbit-previous]');
      const next = root.querySelector('[data-orbit-next]');
      const galleryPrevious = root.querySelector('[data-gallery-previous]');
      const galleryNext = root.querySelector('[data-gallery-next]');
      const galleryCounter = root.querySelector('[data-gallery-counter]');
      const instruction = root.querySelector('[data-orbit-instruction]');
      if (!stage || !thumbs.length) return;

      const instructionStorageKey = 'choices-orbit-instruction-seen';
      const dismissInstruction = () => {
        if (!instruction || instruction.classList.contains('is-dismissed')) return;
        instruction.classList.add('is-dismissed');
        try {
          window.sessionStorage.setItem(instructionStorageKey, 'true');
        } catch (error) {
          return;
        }
      };

      try {
        if (window.sessionStorage.getItem(instructionStorageKey) === 'true') {
          instruction?.classList.add('is-dismissed');
        }
      } catch (error) {
        instruction?.classList.remove('is-dismissed');
      }

      root.querySelectorAll('.choices-orbit__thumb img').forEach((thumbImage) => {
        applyCutout(thumbImage, thumbImage.getAttribute('src'), 180);
      });

      let activeIndex = 0;
      let galleryIndex = 0;
      let dragDegrees = 0;
      let dragging = false;
      let dragged = false;
      let lastPointerAngle = 0;
      let lastMoveTime = 0;
      let angularVelocity = 0;
      let suppressLink = false;
      let animationFrame = 0;
      let clipFrame = 0;

      const visibleCount = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        return Math.min(thumbs.length, mobile ? 8 : 12);
      };

      const normalizeAngle = (degrees) => {
        let value = degrees;
        while (value > 180) value -= 360;
        while (value < -180) value += 360;
        return value;
      };

      const pointerAngle = (event) => {
        const rect = stage.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        return Math.atan2(event.clientY - centerY, event.clientX - centerX) * 180 / Math.PI;
      };

      const positionThumbs = () => {
        const mobile = window.matchMedia('(max-width: 749px)').matches;
        const visible = visibleCount();
        const radius = stage.clientWidth * (mobile ? 0.43 : 0.445);

        thumbs.forEach((thumb, index) => {
          let relative = index - activeIndex;
          if (relative > thumbs.length / 2) relative -= thumbs.length;
          if (relative < -thumbs.length / 2) relative += thumbs.length;
          const visibleOffset = Math.abs(relative) <= Math.floor(visible / 2);
          const angle = (((relative / visible) * 360) - 90 + dragDegrees) * Math.PI / 180;
          thumb.style.setProperty('--orbit-x', `${Math.cos(angle) * radius}px`);
          thumb.style.setProperty('--orbit-y', `${Math.sin(angle) * radius}px`);
          thumb.style.setProperty('--orbit-scale', index === activeIndex ? '1.12' : '1');
          thumb.style.setProperty('--orbit-opacity', visibleOffset ? '1' : '0');
          thumb.style.pointerEvents = visibleOffset ? 'auto' : 'none';
          thumb.tabIndex = visibleOffset ? 0 : -1;
        });
      };

      const schedulePosition = () => {
        if (animationFrame) return;
        animationFrame = window.requestAnimationFrame(() => {
          animationFrame = 0;
          positionThumbs();
        });
      };

      const syncHeaderClip = () => {
        if (clipFrame) return;
        clipFrame = window.requestAnimationFrame(() => {
          clipFrame = 0;
          const header = document.querySelector('.section-header');
          if (!header) {
            root.style.setProperty('--orbit-header-clip', '0px');
            return;
          }
          const overlap = Math.max(0, header.getBoundingClientRect().bottom - root.getBoundingClientRect().top);
          root.style.setProperty('--orbit-header-clip', `${Math.min(root.offsetHeight, overlap)}px`);
        });
      };

      const activeGallery = () => {
        const gallery = galleries.find((item) => Number(item.dataset.orbitGallery) === activeIndex);
        return gallery ? Array.from(gallery.querySelectorAll('[data-gallery-image]')) : [];
      };

      const renderGalleryImage = (newIndex, animate = true) => {
        const images = activeGallery();
        const multiple = images.length > 1;
        galleryPrevious?.classList.toggle('is-hidden', !multiple);
        galleryNext?.classList.toggle('is-hidden', !multiple);
        galleryCounter?.classList.toggle('is-hidden', !multiple);
        if (!images.length || !image) return;

        galleryIndex = (newIndex + images.length) % images.length;
        const selectedImage = images[galleryIndex];
        const swapImage = () => {
          const source = selectedImage.dataset.src;
          image.dataset.cutoutState = 'pending';
          image.src = source;
          image.srcset = '';
          image.alt = selectedImage.dataset.alt;
          applyCutout(image, source, 760);
          if (galleryCounter) {
            galleryCounter.textContent = `${String(galleryIndex + 1).padStart(2, '0')} / ${String(images.length).padStart(2, '0')}`;
          }
        };

        if (!animate) {
          swapImage();
          return;
        }

        image.classList.add('is-changing');
        window.setTimeout(() => {
          swapImage();
          image.classList.remove('is-changing');
        }, 90);
      };

      const update = (newIndex) => {
        activeIndex = (newIndex + thumbs.length) % thumbs.length;
        const active = thumbs[activeIndex];
        galleryIndex = 0;
        dragDegrees = 0;
        const updateContent = () => {
          thumbs.forEach((thumb, index) => {
            const selected = index === activeIndex;
            thumb.classList.toggle('is-active', selected);
            thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          if (title) title.textContent = active.dataset.title;
          if (price) price.textContent = active.dataset.price;
          if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
          if (link) {
            link.href = active.dataset.url;
            link.setAttribute('aria-label', active.dataset.title);
          }
          if (button) button.href = active.dataset.url;
          renderGalleryImage(0);
          positionThumbs();
        };

        updateContent();
      };

      const stopControlPointer = (event) => {
        event.stopPropagation();
      };

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
        thumb.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (suppressLink || !thumb.dataset.url) return;
          dismissInstruction();
          update(index);
          window.location.assign(thumb.dataset.url);
        });
      });
      previous?.addEventListener('click', () => {
        dismissInstruction();
        update(activeIndex - 1);
      });
      next?.addEventListener('click', () => {
        dismissInstruction();
        update(activeIndex + 1);
      });
      galleryPrevious?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        renderGalleryImage(galleryIndex - 1);
      });
      galleryNext?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        renderGalleryImage(galleryIndex + 1);
      });
      [previous, next, galleryPrevious, galleryNext].forEach((control) => {
        control?.addEventListener('pointerdown', stopControlPointer);
        control?.addEventListener('pointerup', stopControlPointer);
        control?.addEventListener('pointercancel', stopControlPointer);
      });
      link?.addEventListener('click', (event) => {
        if (suppressLink) event.preventDefault();
      });
      stage.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          update(activeIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          update(activeIndex + 1);
        }
      });
      stage.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('.choices-orbit__hero, [data-orbit-previous], [data-orbit-next], [data-gallery-previous], [data-gallery-next]')) return;
        dragging = true;
        dragged = false;
        dragDegrees = 0;
        angularVelocity = 0;
        lastPointerAngle = pointerAngle(event);
        lastMoveTime = performance.now();
        stage.classList.add('is-dragging');
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {
        }
      });

      stage.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const now = performance.now();
        const nextAngle = pointerAngle(event);
        const rawDelta = normalizeAngle(nextAngle - lastPointerAngle);
        const delta = Math.max(-18, Math.min(18, rawDelta));
        const elapsed = Math.max(now - lastMoveTime, 1);
        dragDegrees += delta;
        angularVelocity = angularVelocity * 0.72 + (delta / elapsed) * 0.28;
        lastPointerAngle = nextAngle;
        lastMoveTime = now;
        if (Math.abs(dragDegrees) > 3) {
          dragged = true;
          dismissInstruction();
        }
        schedulePosition();
      });

      stage.addEventListener('pointerup', (event) => {
        if (!dragging) return;
        dragging = false;
        stage.classList.remove('is-dragging');
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
        const stepAngle = 360 / visibleCount();
        const projectedDegrees = dragDegrees + Math.max(-0.8, Math.min(0.8, angularVelocity)) * 18;
        let steps = Math.round(-projectedDegrees / stepAngle);
        if (steps === 0 && Math.abs(dragDegrees) > stepAngle * 0.22) {
          steps = dragDegrees > 0 ? -1 : 1;
        }
        suppressLink = dragged;
        if (steps === 0) {
          dragDegrees = 0;
          positionThumbs();
        } else {
          update(activeIndex + steps);
        }
        window.setTimeout(() => {
          suppressLink = false;
        }, 80);
      });

      stage.addEventListener('pointercancel', () => {
        if (!dragging) return;
        dragging = false;
        dragDegrees = 0;
        stage.classList.remove('is-dragging');
        positionThumbs();
      });

      window.addEventListener('scroll', syncHeaderClip, { passive: true });
      window.addEventListener('resize', () => {
        schedulePosition();
        syncHeaderClip();
      }, { passive: true });
      renderGalleryImage(0, false);
      positionThumbs();
      syncHeaderClip();
    };

    const initializeAll = () => document.querySelectorAll('[data-choices-orbit]').forEach(initializeOrbit);
    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choices-runway"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('[data-choices-runway]').forEach(root=>{const rail=root.querySelector('[data-runway-rail]'),looks=[...root.querySelectorAll('.choices-runway__look')];if(!rail||!looks.length)return;let active=0;const update=()=>{const center=rail.scrollLeft+rail.clientWidth/2;let best=0,d=Infinity;looks.forEach((look,i)=>{const x=look.offsetLeft+look.offsetWidth/2,nd=Math.abs(x-center);if(nd<d){d=nd;best=i}});active=best;looks.forEach((look,i)=>look.classList.toggle('is-active',i===active))};const go=i=>looks[(i+looks.length)%looks.length].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});root.querySelector('[data-runway-prev]')?.addEventListener('click',()=>go(active-1));root.querySelector('[data-runway-next]')?.addEventListener('click',()=>go(active+1));rail.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});rail.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();go(active-1)}if(e.key==='ArrowRight'){e.preventDefault();go(active+1)}});requestAnimationFrame(()=>{update();go(0)})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
